import BaseService from "./base.service";

export default class BusinessService extends BaseService {
    constructor(ctx) {
        super(ctx)
    }

    getBusinessHome = (query) => {
        return this.get('/business/business-home', query)
    }

    getOptionBusines = (query) => {
        return this.get('/business/get-options', query)
    }
}
